import React from "react"

const InfoSection = () => {
  return (
    <div className='wrapper py-5'>
      <div className='grid'>
        <div className='infoBox'>
          <div className='infoBoxCircle'>
            <img src='/happy-icon.png' alt='' />
          </div>
          <h3>Müşteri Memnuniyeti</h3>
          <p>Bizim için en önemli konu sizin memnuniyetiniz.</p>
        </div>
        <div className='infoBox'>
          <div className='infoBoxCircle'>
            <img src='/professional-icon.png' alt='' />
          </div>
          <h3>Profesyonel Hizmet</h3>
          <p>İhtiyaçlarınıza yönelik en profesyonel hizmeti sağlıyoruz.</p>
        </div>
        <div className='infoBox'>
          <div className='infoBoxCircle'>
            <img src='/home2-icon.svg' alt='' />
          </div>
          <h3>Evinize Zarar Vermeyin</h3>
          <p>Evinize zarar vermeden en kaliteli şekilde hizmet veriyoruz.</p>
        </div>
      </div>
    </div>
  )
}

export default InfoSection
